import { render, staticRenderFns } from "./job-form.vue?vue&type=template&id=f56c8104&scoped=true"
import script from "./job-form.vue?vue&type=script&lang=js"
export * from "./job-form.vue?vue&type=script&lang=js"
import style0 from "./job-form.vue?vue&type=style&index=0&id=f56c8104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56c8104",
  null
  
)

export default component.exports